module.exports = __webpack_public_path__ + "img/request.73bd33d2.svg";